module.exports = __webpack_public_path__ + "media/images/icon_birthplace-ed362e60ce7e2fd5cc34edfa71dbb7c9.svg";